<template>
  <div class="slide">
    <div class="section text-center question">
      <h4>{{ answers.text }}</h4>
    </div>

    <div class="answers-section">
      <div class="row">
        <div class="col-md-6" v-for="(option, i) in answers.responses" :key="i">
          <div class="answers">
            <input v-model="answer" class="answer" :id="`answer-${i}`" name="answer" type="radio" :value="option.value" /><label class=" text-center" :for="`answer-${i}`"
              ><span>{{ option.text }}</span></label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import quiz from '../../appdata/quiz.js'

export default {
  mounted() {
    var answerIndex = this.storeAnswer.map(item => item.id).indexOf(this.index)
    if (answerIndex > -1) {
      this.answer = this.storeAnswer[answerIndex].value
    }
  },
  data() {
    return {
      quiz: quiz,
      answer: null
    }
  },

  watch: {
    // whenever question changes, this function will run
    answer: function(newAnswer, oldAnswer) {
      let answers = this.storeAnswer
      const answer = {
        id: this.index,
        value: newAnswer
      }
      var removeIndex = answers.map(item => item.id).indexOf(this.index)
      ~removeIndex && answers.splice(removeIndex, 1)
      answers.push(answer)
      this.storeAnswer = answers
      this.$eventBus.$emit('quiz-nav', 'next')
    }
  },
  computed: {
    id: {
      get() {
        return parseInt(this.$route.path.substring(1))
      }
    },
    answers: {
      get() {
        return this.quiz.questions[this.index]
      }
    },
    index: {
      get() {
        let splitName = this.$route.name.split('-')
        return parseInt(splitName[1]) - 1
      }
    },
    storeAnswer: {
      get() {
        return this.$store.state.answers
      },
      set(value) {
        this.$store.commit('setAnswers', { answers: value })
      }
    }
  }
}
</script>

<style lang="scss">
.question {
  color: #000;
  h4 {
    font-weight: 500;
    max-width: 780px;
    margin: 0 auto;
  }
}
.answers-section {
  background: #435a69;
  color: #fff;
  label {
    text-align: left;
  }
  padding: 80px;
  @media (max-width: 768px) {
    padding: 10px;
  }
}

.answers {
  label {
    @media (min-width: 768px) {
      font-size: 25px;
    }
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
}

input.answer {
  display: none;
  + label {
    padding-left: 0px;
    position: relative;
    border: 2px solid #fff;
    display: block;
    text-align: center;
    cursor: pointer;
    margin: 20px 35px;
    font-size: 19.6px;
    padding: 10px;
    &:hover {
      background: #f04e23;
      border-color: #f04e23;
    }
    @media (max-width: 768px) {
      padding: 10px;
      margin: 14px 10px;
    }
  }
  &:checked + label {
    background: #f04e23;
    border-color: #f04e23;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Question.vue